<template>
  <div style="position: relative">
    <div class="lecard-marker" v-show="!showTooltip">
      <svg width="49" height="48" viewBox="0 0 49 48" xmlns="http://www.w3.org/2000/svg"><path d="M25 45Q7 32.94 7 21c0-9.941 8.059-18 18-18s18 8.059 18 18q0 11.94-18 24m0-16a8 8 0 1 0 0-16 8 8 0 0 0 0 16" fill="#3F3E3E"/></svg>
    </div>

    <div class="message-error" v-if="msgErro">
      <div class="conteudo animated bounceInDown">
        <i class="fa fa-warning"></i> {{msgErro}}
      </div>
    </div>

    <div class="btn-map" v-if="!msgErro && showMap">
      <button class="btn btn-primary btn-block py-2" @click="confirmar()">Confirmar localização</button>
    </div>

    <div class="map-container" v-if="center">
      <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          @update:center="centerUpdate"
          @movestart="movestart"
          @leaflet:load="isMapLoad"
          @ready="mapReady">
        <l-tile-layer :url="url" :attribution="attribution"/>
        <l-marker :lat-lng="userLocation" v-if="showTooltip && userLocation">
          <l-icon
              :icon-size="[48, 48]"
              :icon-anchor="[24, 48]"
              :icon-url="imgIcon"
          />
          <l-tooltip :options="tooltipOption">
            <div class="text-center">
              <div class="font-weight-bold">Você está aqui</div>
              <small>Mova para ajustar sua posição</small>
            </div>
          </l-tooltip>
        </l-marker>
        <l-circle :lat-lng="center" :radius="raio_usuario" :weight="0" :fillOpacity="0.001" @ready="(c) => this.circle = c"/>
        <l-circle :lat-lng="empresa" :radius="raio_empresa" :weight="2" :fillOpacity="0.001" v-if="empresa && raio_empresa"/>
      </l-map>
    </div>
    <div v-if="!showMap" class="mt-5">
      <loading fullscrean="true" text="Carregando mapa"/>
    </div>
  </div>
</template>

<script>
  import { latLng, Icon, point } from "leaflet";
  import { LMap, LTileLayer, LMarker, LPopup, LTooltip , LControl, LIcon, LCircle } from "vue2-leaflet";

  import imgIcon from '../../assets/map.svg';
  import Loading from "../Loading";

  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  export default {
    name: "MapLeaflet",
    components: {Loading, LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LIcon, LCircle },
    props: ['dados'],

    data() {
      return {
        map: null,
        showMap: false,
        zoom: 16,
        imgIcon: imgIcon,

        msgErro: '',
        isInside: true,
        userLocation: null,
        center: null,
        empresa: null,
        raio_empresa: null,

        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: { zoomSnap: 0.5, minZoom: 12, maxZoom: 18, zoomControl: true },
        showTooltip: true,
        tooltipOption: { permanent: true, direction: 'top', offset: point([-16, -24])},

        circle: null,
        raio_usuario: null
      };
    },

    methods: {
      isMapLoad() {
        this.showMap = true;
      },

      isInsideCircle(e) {
        if (this.validarDistancia()) {
          const distance = this.map.distance(e, this.center);
          this.isInside = distance < this.circle.getRadius();
          this.msgErro = !this.isInside ? "Você está muito distante do lugar que informou!" : "";

          this.circle.setStyle({
            fillColor: this.isInside ? '#3388ff' : '#f03',
            color: this.isInside ? '#3388ff' : '#f03',
            fillOpacity: this.isInside ? 0 : 0.3,
            weight: this.isInside ? 0 : 1,
          });
        }
      },

      centerUpdate(center) {
        this.userLocation = center;
        this.showTooltip = true;

        this.isInsideCircle(center);
      },

      movestart() {
        this.showTooltip = false;
      },

      validarDistancia() {
        const distance = this.map.distance(this.empresa, this.userLocation);

        if (distance > this.raio_empresa) {
          this.msgErro = "Infelizmente não entregamos nesta região!";
          return false;
        }

        return true;
      },

      confirmar() {
        if (!this.validarDistancia()) {
          return;
        }

        this.$emit('editarDados', this.userLocation);
        this.remove();
      },

      mapReady(m) {
        this.map = m;
        this.validarDistancia();
      },

      remove() {
        this.center = null;
        this.showMap = false;
      },

      openMapa(endereco) {
        if (!endereco || !this.dados.lat_empresa || !this.dados.long_empresa) {
          this.remove();
          return;
        }

        this.msgErro = "";
        this.isInside = true;

        const local = latLng(endereco.lat_endereco, endereco.long_endereco);
        this.empresa = latLng(this.dados.lat_empresa, this.dados.long_empresa);
        this.raio_empresa = parseInt(this.dados.raio_empresa);
        this.raio_usuario = parseInt(endereco.buscar_mapa ? this.dados.raio_cidade : 600);
        this.zoom = endereco.buscar_mapa ? 13 : 16;

        if (local) {
          this.userLocation = local;
          this.center = local;
        }

        if (this.map) {
          this.validarDistancia();
        }
      }
    }
  };
</script>
<style>
  .lecard-marker {
    position: absolute;
    top: calc(50% - 28px);
    left: 50%;
    z-index: 99999;
    transform: translate(-50%,-50%);
  }

  .message-error {
    position: absolute;
    top: 12px;
    left: 50%;
    z-index: 99999;
    transform: translateX(-50%);
    width: 95%;
    max-width: 600px;
  }

  .message-error .conteudo {
    background-color: #ff3a44;
    padding: 16px 0;
    color: #fff;
    text-align: center;
    border-radius: 4px;
  }

  .btn-map {
    position: absolute;
    bottom: 50px;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 99999;
    width: 90%;
    max-width: 300px;
  }

  .map-container {
    height: calc(80vh - 57px);
  }

  @media (max-width: 767px) {
    .map-container {
      height: calc(100vh - 72px);
    }

    .btn-map {
      position: fixed;
    }
  }
</style>
